if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      // BEELTRA: ModalDialog (clase base) cierra el modal en cualquier
      // "pointerup" fuera de deferred-media/product-model -- sin esto,
      // el propio click en los botones prev/next cerraria el lightbox
      // antes de que su handler de "click" llegue a ejecutarse.
      const prevButton = this.querySelector('[data-modal-nav="previous"]');
      const nextButton = this.querySelector('[data-modal-nav="next"]');
      [prevButton, nextButton].forEach((button) => {
        if (!button) return;
        button.addEventListener('pointerup', (event) => event.stopPropagation());
      });
      if (prevButton) prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
      if (nextButton) nextButton.addEventListener('click', this.showNextMedia.bind(this));
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      this.setActiveMedia(activeMedia);
    }

    // BEELTRA: helpers de navegacion siguiente/anterior del lightbox --
    // reutilizan el mismo mecanismo de Dawn (scrollIntoView + clase
    // .active) que ya usaba showActiveMedia(), solo factorizado para
    // poder llamarlo tambien desde los botones prev/next.
    setActiveMedia(activeMedia) {
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      this.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('active'));
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('[data-media-id]'));
    }

    getActiveIndex(items) {
      const index = items.findIndex((item) => item.classList.contains('active'));
      return index === -1 ? 0 : index;
    }

    showNextMedia() {
      const items = this.getMediaItems();
      if (items.length < 2) return;
      const nextIndex = (this.getActiveIndex(items) + 1) % items.length;
      this.setActiveMedia(items[nextIndex]);
    }

    showPreviousMedia() {
      const items = this.getMediaItems();
      if (items.length < 2) return;
      const prevIndex = (this.getActiveIndex(items) - 1 + items.length) % items.length;
      this.setActiveMedia(items[prevIndex]);
    }
  });
}
